import _ from "lodash";


const CheckServices = {
    checkPublications(publications, items_part, plan_author=1) {
        let publicationsById = [];
        let name_publication = "";
        let count_author_fact = 0;
        let difference_publication = [];
        let part_item = _.filter(items_part, (i) => {return i.is_publication});
        let error_publication = [];
        const item_data_ids = _.cloneDeep(part_item).map(x => x.id);
        const publications_id = _.cloneDeep(publications).map(x => x.eff_contract.id);
        const difference = _.difference(item_data_ids, publications_id)

        _.forEach(difference, (i) => {difference_publication.push(
            _.find(part_item, (j) => {
                    return j.id === i
                }))
            });
        if (difference_publication.length !== 0) {
            _.forEach(difference_publication, (i) => {
                error_publication.push(`${i?.indicator_name} - отсутствует в контракте`)
            });
        }
        publicationsById = _.values(_.groupBy(_.pullAllBy(publications, difference_publication, 'id_eff_con'), 'id_eff_con'));
        _.forEach(publicationsById, (publicationById) => {
            _.forEach(publicationById, (value, key) => {
                name_publication = value.eff_contract.indicator_name;
                count_author_fact += Number(value.fact);
            })
            if ((count_author_fact).toFixed(1) < Number(plan_author).toFixed(1)) {
                error_publication.push(`${name_publication} - недостаточное количество публицкаций`);
            }
            count_author_fact = 0;
        });

        return error_publication;
    },

    checkFactPart(part_data, difference_part) {
        let error_parts = []
        _.forEach(_.pullAllBy(part_data, difference_part, 'eff_contract.id'), (value, key) => {
            if (Number(value.plan) != NaN) {
                // debugger
                let plan = Number(value.eff_contract.plan.replace(/[^\d]/g, ''));
                let fact = Number(value.fact.replace(/[^\d]/g, ''));
                if (plan > fact) {
                    error_parts.push(`${value.eff_contract?.indicator_name} - недостаточное количество по плану`)
                }
            }
        });

        return error_parts;
    },

    checkDifferencePart(basic_data, part_item) {
        let error_part = []
        let difference_part = []
        let basic_item = _.filter(_.cloneDeep(part_item), (i) => {
            return !i.is_publication
        });

        _.forEach(_.difference(basic_item.map(x => x.id), basic_data.map(x => x.eff_contract.id)),
            (i) => {
                difference_part.push(_.find(part_item, (j) => {
                    return j.id === i
                }))
            }
        );

        if (difference_part.length !== 0) {
            _.forEach(difference_part, (i) => {
                error_part.push(`${i?.indicator_name} - не заполнена часть`)
            });
        }

        return [error_part, difference_part]
    },

    listContracts(personContractList, listContracts) {
        if (personContractList === null) return []
        let current_items = [];
        const clonePersonEffContract = _.cloneDeep(personContractList);
        const publications = _.filter(clonePersonEffContract,(i) => {return i.author !== null});
        const items = _.filter(clonePersonEffContract,  {"author": null});
        const plan_author = _.find(listContracts, (i)=>{return i.is_publication})?.plan || 1;

        _.forEach(_.difference(listContracts.map(x => x.id), items.map(x => x.eff_contract.id)),
            (i)=>{current_items.push(_.find(listContracts,(j)=>{return j.id === i}))});
        if (this.checkPublications(publications, listContracts, Number(plan_author)).length === 0) {
            return current_items = _.filter(current_items,(i)=> {return !i.is_publication});
        }
        return current_items
    },

    checkedPath(personEffContracts, listContract) {
        let basic_data = _.cloneDeep(personEffContracts);
        let publications = _.remove(basic_data, (i)=>{ return i.eff_contract.is_publication});
        const plan_author = _.find(listContract, (i)=>{return i.is_publication})?.plan || 1;
        const [difErrors, difference] = this.checkDifferencePart(basic_data, listContract);
        const factErrors = this.checkFactPart(basic_data, difference);
        const publicationErrors = this.checkPublications(publications, listContract, plan_author)

        return [...difErrors, ...factErrors, ...publicationErrors];
    },

    checkDate() {
        const currentDate = new Date();
        const startDate = new Date(currentDate.getFullYear(), 5, 1);
        const endDate = new Date(currentDate.getFullYear(), 8, 10, 17);

        return currentDate >= startDate && currentDate < endDate
    },


}

export default CheckServices